"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const transactionSigningSelector_1 = require("../selectors/transactionSigningSelector");
const TransactionSigningOneToken_1 = __importDefault(require("./TransactionSigningOneToken"));
const ChangePasswordOneToken_1 = __importDefault(require("./ChangePasswordOneToken"));
const TransactionSigningOTP_1 = __importDefault(require("./TransactionSigningOTP"));
const InvalidOTP_1 = __importDefault(require("./InvalidOTP"));
const TransactionSigningApproved_1 = __importDefault(require("./TransactionSigningApproved"));
const ExceedMaximumRetry_1 = __importDefault(require("./ExceedMaximumRetry"));
const GeneralError_1 = __importDefault(require("./GeneralError"));
const TransactionSigningEmailVerification_1 = __importDefault(require("./TransactionSigningEmailVerification"));
const FirstTimeTransactionSigning_1 = __importDefault(require("./FirstTimeTransactionSigning"));
const LostOrChanged_1 = __importDefault(require("@/features/login2fa/containers/LostOrChanged"));
const HardTokenApproveTransaction_1 = __importDefault(require("./HardTokenApproveTransaction"));
//import { LayoutStatus } from '@/features/login2fa/types';
//import PopupTwoFASigning from '@/features/login2fa/containers/PopupTwoFASigning';
//import { LoadingSpinner } from "@hdh-core/react-design-system";
const TransactionSigningPrompter_1 = __importDefault(require("./TransactionSigningPrompter"));
const TransactionSigningOfflineOTP_1 = __importDefault(require("./TransactionSigningOfflineOTP"));
const InvalidOfflineOTP_1 = __importDefault(require("./InvalidOfflineOTP"));
const NoActiveHardToken_1 = __importDefault(require("./NoActiveHardToken"));
const NoActiveSoftToken_1 = __importDefault(require("./NoActiveSoftToken"));
const HardTokenNoTransaction_1 = __importDefault(require("./HardTokenNoTransaction"));
const constants_1 = require("../constants");
const R4TransactionSigningOneToken_1 = __importDefault(require("@/features/r4/transaction-signing/R4TransactionSigningOneToken"));
const R4HardTokenApproveTransaction_1 = __importDefault(require("@/features/r4/transaction-signing/R4HardTokenApproveTransaction"));
const TransactionSigning = ({ onClose }) => {
    const { showTransactionSigningOTP, showTransactionSiginingOneToken, showChangePasswordOneToken, showTransactionSigningOfflineOTP, showChangePasswordOfflineOTP, showInvalidOTP, showInvalidOfflineOTP, showResendOTPSuccess, showOneTokenWithFooter, showChangePasswordOneTokenWithFooter, showTransactionSigningApproved, showExceedMaximumRetry, showUserNoActiveHardToken, showUserNoActiveSoftToken, showGeneralError, showTransactionSigningEmailVerification, showResendEmailOTPSuccess, showFirstTimeTransactionSigning, showLostOrChange, showTransactionSigningHardTokenOTP, showTransactionSigningHardTokenOTPNoFinancial, showTransactionSigningPrompter
    //loading,
     } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    if (showTransactionSigningOTP || showResendOTPSuccess) {
        return react_1.default.createElement(TransactionSigningOTP_1.default, { onClose: onClose });
    }
    if (showTransactionSigningEmailVerification || showResendEmailOTPSuccess) {
        return react_1.default.createElement(TransactionSigningEmailVerification_1.default, { onClose: onClose });
    }
    if (showFirstTimeTransactionSigning) {
        return react_1.default.createElement(FirstTimeTransactionSigning_1.default, { onClose: onClose });
    }
    if (showLostOrChange) {
        return react_1.default.createElement(LostOrChanged_1.default, null);
    }
    // if (layoutStatus === LayoutStatus.HARD_WARE_TOKEN) {
    //   return (
    //
    //   );
    // }
    if (showTransactionSigningHardTokenOTP) {
        if (constants_1.isR4) {
            return react_1.default.createElement(R4HardTokenApproveTransaction_1.default, null);
        }
        else {
            return react_1.default.createElement(HardTokenApproveTransaction_1.default, { onClose: onClose });
        }
    }
    if (showTransactionSigningHardTokenOTPNoFinancial) {
        return react_1.default.createElement(HardTokenNoTransaction_1.default, { onClose: onClose });
    }
    if (showTransactionSiginingOneToken || showOneTokenWithFooter) {
        if (constants_1.isR4) {
            return react_1.default.createElement(R4TransactionSigningOneToken_1.default, { onClose: onClose });
        }
        else {
            return react_1.default.createElement(TransactionSigningOneToken_1.default, { onClose: onClose });
        }
    }
    if (showChangePasswordOneToken || showChangePasswordOneTokenWithFooter) {
        return react_1.default.createElement(ChangePasswordOneToken_1.default, { onClose: onClose });
    }
    if (showTransactionSigningOfflineOTP || showChangePasswordOfflineOTP) {
        return react_1.default.createElement(TransactionSigningOfflineOTP_1.default, { onClose: onClose });
    }
    if (showTransactionSigningApproved) {
        return react_1.default.createElement(TransactionSigningApproved_1.default, null);
    }
    if (showInvalidOTP) {
        // or invalid one token?
        return react_1.default.createElement(InvalidOTP_1.default, null);
    }
    if (showInvalidOfflineOTP) {
        // or invalid one token?
        return react_1.default.createElement(InvalidOfflineOTP_1.default, null);
    }
    if (showExceedMaximumRetry) {
        // or invalid one token?
        return react_1.default.createElement(ExceedMaximumRetry_1.default, null);
    }
    if (showUserNoActiveHardToken) {
        return react_1.default.createElement(NoActiveHardToken_1.default, null);
    }
    if (showUserNoActiveSoftToken) {
        return react_1.default.createElement(NoActiveSoftToken_1.default, null);
    }
    if (showGeneralError) {
        // or invalid one token?
        return react_1.default.createElement(GeneralError_1.default, null);
    }
    if (showTransactionSigningPrompter) {
        return react_1.default.createElement(TransactionSigningPrompter_1.default, { onClose: onClose });
    }
    return react_1.default.createElement("div", null);
};
exports.default = TransactionSigning;
